import React, { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Apps from './components/Apps';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  // Disable scroll-snap while an input is focused (prevents mobile keyboard
  // resize from snapping the page to a different section).
  useEffect(() => {
    const appEl = document.querySelector('.App');
    if (!appEl) return;
    const isMobile = () => window.innerWidth <= 768;
    const onFocusIn = (e) => {
      if (isMobile() && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) {
        appEl.style.scrollSnapType = 'none';
      }
    };
    const onFocusOut = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        appEl.style.scrollSnapType = '';
      }
    };
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('focusout', onFocusOut);
    return () => {
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('focusout', onFocusOut);
    };
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <Features />
      <Apps />
      <div className="snap-section">
        <Contact />
        <Footer />
      </div>
    </div>
  );
}

export default App;
